import { render, staticRenderFns } from "./HistorieView.vue?vue&type=template&id=796dfe78&"
import script from "./HistorieView.vue?vue&type=script&lang=js&"
export * from "./HistorieView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports